module.exports = __webpack_public_path__ + "img/messange.fbcdc264.svg";